module.exports = __webpack_public_path__ + "static/media/GoogleSans-MediumItalic.8fd37379.ttf";